import { QuickAddComponent } from '@theme/quick-add';

class CamixaUpsellQuickAdd extends QuickAddComponent {
  constructor() {
    super();
    const openPreview = this.handleClick;
    this.handleClick = async (event) => {
      event.preventDefault();
      const button = this.querySelector('button');
      const error = this.querySelector('[role="status"]');
      if (!button || button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      try {
        await openPreview(event);
      } catch {
        if (error) error.hidden = false;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };
  }

  get productPageUrl() {
    return this.dataset.productUrl || '';
  }

  async fetchProductPage(url) {
    const page = await super.fetchProductPage(url);
    if (!page?.querySelector('[data-product-grid-content]')) throw new Error('Product preview unavailable');
    return page;
  }

  async updateQuickAddModal(productGrid) {
    productGrid.querySelectorAll('.camixa-upsell, .view-more-details__wrapper').forEach((block) => block.remove());
    await super.updateQuickAddModal(productGrid);
    document.querySelectorAll('#quick-add-modal-content .view-product-title a, #quick-add-modal-content .product-header > a')
      .forEach((title) => title.removeAttribute('href'));
  }
}

if (!customElements.get('camixa-upsell-quick-add')) {
  customElements.define('camixa-upsell-quick-add', CamixaUpsellQuickAdd);
}
